import { AuthProvider } from 'react-admin';
import { defaultApiServer } from './config';

const adminPrefix = 'admin';

const apiUrl = (path: string) => {
    const apiServer = defaultApiServer();
    return [apiServer, adminPrefix, path].join('/')
}

const mergeConfig = (config?: RequestInit) => {
    const jwtToken = localStorage.getItem('token');
    const authHeader = jwtToken ? {
        'Authorization': `Bearer ${jwtToken}`,
    } : undefined;
    return {
        method: 'GET',
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            'Authorization': `Bearer ${jwtToken}`,
            ...authHeader,
            ...config?.headers,
        },
        mode: 'cors',
        ...config,
    } as RequestInit;
}

const authProvider: AuthProvider = {
    login: ({ username, password }) => {
        const url = apiUrl('administrators/token')
        const config = mergeConfig({
            method: 'POST',
            body: JSON.stringify({
                email: username,
                password,
            }),
        });
        return fetch(url, config)
            .then(res => res.json())
            .then(json => {
                console.log({json});
                localStorage.setItem('token', json.data.token);
            })
            .catch(e => {
                console.error(e);
                return Promise.reject();
            });
    },
    logout: () => {
        localStorage.removeItem('token');
        return Promise.resolve();
    },
    checkAuth: () =>
        localStorage.getItem('token') ? Promise.resolve() : Promise.reject(),
    checkError:  (error) => {
        const status = Number(error.status);
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject(error.message);
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    getIdentity: () => {
        const token = localStorage.getItem('token')
        const parts = token?.split('.') || [];
        const payload = parts?.length > 0 ? JSON.parse(atob(parts[1])) : '' || { sub: 'unknown' };
        return Promise.resolve({
            id: payload.sub,
            fullName: payload.user.email,
        })
    },
    getPermissions: () => Promise.resolve(''),
};

export default authProvider;
